import { Eye, Phone } from 'lucide-react'
import type { BdrLead } from '@/types'
import {
  formatBdrDate,
  getAllLeadsStatusInfo,
  getAllLeadsTemperature,
  getBdrInitials,
} from '@/components/BdrPanelV2/bdrAllLeadsTableUtils'

interface BdrAllLeadsTableRowsProps {
  leads: BdrLead[]
  openLeadDetail: (lead: BdrLead) => void
  openRegTentativaModal: (lead: BdrLead) => void
}

export function BdrAllLeadsTableRows({
  leads,
  openLeadDetail,
  openRegTentativaModal,
}: BdrAllLeadsTableRowsProps) {
  return (
    <>
      {leads.map((lead) => {
        const score = lead.score ?? 0
        const temp = getAllLeadsTemperature(score)
        const status = getAllLeadsStatusInfo(lead.status)
        const fase = lead.cadencia?.fase

        return (
          <tr
            key={lead.id}
            onClick={() => openLeadDetail(lead)}
            className="border-b border-white/[0.04] hover:bg-white/[0.02] cursor-pointer transition-colors"
          >
            <td className="px-3 py-2.5">
              <div className="flex items-center gap-2.5">
                <div className="w-9 h-9 rounded-full bg-accent/10 flex items-center justify-center text-accent font-bold text-sm shrink-0">
                  {getBdrInitials(lead.empresa)}
                </div>
                <div className="min-w-0">
                  <div className="text-text-primary font-medium truncate">{lead.empresa}</div>
                  {lead.segmento && (
                    <div className="text-text-muted text-[10px] truncate">{lead.segmento}</div>
                  )}
                </div>
              </div>
            </td>

            <td className="px-3 py-2.5">
              <div className="text-text-primary truncate">{lead.contato}</div>
              {lead.cargo && <div className="text-text-muted text-[10px] truncate">{lead.cargo}</div>}
            </td>

            <td className="px-3 py-2.5">
              <div className="flex items-center gap-1.5">
                <span
                  className="text-[10px] font-bold px-1.5 py-0.5 rounded-full uppercase tracking-wider"
                  style={{ color: status.color, backgroundColor: `${status.color}18` }}
                >
                  {status.label}
                </span>
                {fase && <span className="text-text-muted text-[10px]">F{fase}</span>}
              </div>
            </td>

            <td className="px-3 py-2.5">
              <div className="flex items-center gap-2" title={lead.score == null ? 'Lead sem score' : undefined}>
                <div className="flex-1 max-w-[80px]">
                  <div className="h-1.5 bg-white/[0.06] rounded-full overflow-hidden">
                    <div
                      className="h-full rounded-full transition-all duration-500"
                      style={{
                        width: `${Math.min(score, 100)}%`,
                        backgroundColor: temp.color,
                      }}
                    />
                  </div>
                </div>
                <span className="text-text-primary font-medium w-8 text-right">
                  {lead.score != null ? `${score}%` : '-'}
                </span>
                <span
                  className="text-[10px] font-medium px-1.5 py-0.5 rounded-full"
                  style={{ color: temp.color, backgroundColor: `${temp.color}18` }}
                >
                  {temp.label}
                </span>
              </div>
            </td>

            <td className="px-3 py-2.5 text-text-muted whitespace-nowrap">
              {formatBdrDate(lead.dataEntrada)}
            </td>

            <td className="px-3 py-2.5">
              <div className="flex items-center justify-end gap-1" onClick={(e) => e.stopPropagation()}>
                <button
                  onClick={() => openLeadDetail(lead)}
                  title="Ver detalhes"
                  className="min-w-[44px] min-h-[44px] flex items-center justify-center rounded-lg hover:bg-white/[0.06] transition-colors"
                >
                  <Eye size={15} className="text-text-muted" />
                </button>
                <button
                  onClick={() => openRegTentativaModal(lead)}
                  title="Registrar tentativa"
                  className="min-w-[44px] min-h-[44px] flex items-center justify-center rounded-lg hover:bg-white/[0.06] transition-colors"
                >
                  <Phone size={15} className="text-text-muted" />
                </button>
              </div>
            </td>
          </tr>
        )
      })}
    </>
  )
}
